import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';

import { AppState } from './models/app-state';

/**
 * @deprecated Use useAppSelector from ./store.ts
 */
export const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
